// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3I5y2","Open":"SideDrawer_Open__2xBaD","Close":"SideDrawer_Close__3L83H","Logo":"SideDrawer_Logo__1Z7ii"};